// removed by extract-text-webpack-plugin
module.exports = {"adventuresPage":"style__adventuresPage__ekIQL","content":"style__content__1rdtH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/adventures/style.scss
// module id = 1038
// module chunks = 0